import styles from './skeleton.module.css';

export interface SkeletonProps {
  variant?: 'text' | 'pill' | 'block';
  width?: string;
  height?: string;
  className?: string;
}

export function Skeleton({ variant = 'text', width, height, className }: SkeletonProps) {
  return (
    <span
      className={[styles.skeleton, styles[variant], className].filter(Boolean).join(' ')}
      style={{ width, height }}
    />
  );
}

/**
 * The loading state for a list or table. It is announced politely so a screen
 * reader user is told the region is busy rather than told nothing at all.
 */
export function SkeletonRows({ rows = 4, columns = 3 }: { rows?: number; columns?: number }) {
  return (
    <div className={styles.rows} role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">Loading…</span>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <span className={styles.row} key={rowIndex}>
          {Array.from({ length: columns }, (_, columnIndex) => (
            <Skeleton
              key={columnIndex}
              className={columnIndex === 0 ? styles.grow : undefined}
              width={
                columnIndex === 0 ? undefined : `${60 + ((rowIndex + columnIndex) % 3) * 20}px`
              }
            />
          ))}
        </span>
      ))}
    </div>
  );
}
